import React, { useEffect, useState, useMemo } from 'react';
import { MapContainer, TileLayer, Marker, Popup, Circle, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import SantaMonicaLogo from '../../img/santa_monica_logo_rgb.png'; // Certifique-se de ter um logo para a unidade base

// Importar a função da API
import { geo_buscar_escola } from '../../services/api';

// --- CONFIGURAÇÕES ESTÁTICAS (Baseadas no MapaSistema) ---
// "07"	"NOVA IGUAÇU"	-22.76372880	-43.44355611	"#FFFFFF"
// Configuração das Unidades SMREDE
const UNIDADES_CONFIG = [
    { id: "01", nome: "BENTO RIBEIRO", lat: -22.866478, lng: -43.362688, cor: "#FF0000" },
    { id: "02", nome: "MADUREIRA", lat: -22.875417, lng: -43.340733, cor: "#0000FF" },
    { id: "03", nome: "SANTA CRUZ", lat: -22.924783, lng: -43.681378, cor: "#008000" },
    { id: "04", nome: "CASCADURA", lat: -22.880717, lng: -43.32306, cor: "#000000" },
    { id: "05", nome: "TAQUARA", lat: -22.91823, lng: -43.388325, cor: "#800080" },
    { id: "06", nome: "NILOPOLIS", lat: -22.806507, lng: -43.415278, cor: "#FFA500" },
    { id: "07", nome: "NOVA IGUAÇU", lat: -22.763728, lng: -43.443556, cor: "#7e7eff" },
    { id: "09", nome: "SEROPÉDICA", lat: -22.84092, lng: -43.710647, cor: "#00CED1" },
    { id: "10", nome: "BARRA DA TIJUCA", lat: -23.008326, lng: -43.316027, cor: "#FF1493" },
    { id: "11", nome: "CAMPO GRANDE", lat: -22.918895, lng: -43.551892, cor: "#8B4513" },
    { id: "13", nome: "MANGUEIRA", lat: -22.902593, lng: -43.242589, cor: "#f7b7ff" },
    { id: "14", nome: "MARICÁ", lat: -22.911717, lng: -42.820952, cor: "#32CD32" },
    { id: "15", nome: "ILHA DO GOVERNADOR", lat: -22.817818, lng: -43.199021, cor: "#FFD700" },
    { id: "16", nome: "FREGUESIA", lat: -22.936755, lng: -43.336062, cor: "#708090" },
    { id: "17", nome: "RECREIO DOS BANDEIRANTES", lat: -23.018347, lng: -43.472943, cor: "#00FF7F" },
];

// Mapeamento de Tipo de Dependência para Nomes
const DEPENDENCIA_NOME = {
    1: "Federal",
    2: "Estadual",
    3: "Municipal",
    4: "Particular"
};

// Mapeamento de Tipo de Dependência para Cores (Padrão dos outros módulos: Particular=Warning, Pública=Info)
const CORES_DEPENDENCIA = {
    1: "#f00de5", // Azul (Info) - Federal
    2: "#0df086", // Azul (Info) - Estadual
    3: "#0dcaf0", // Azul (Info) - Municipal
    4: "#ffc107"  // Amarelo (Warning) - Particular
};

// --- ÍCONES ---

// 1. Ícone da Unidade SMREDE Base
const schoolIcon = new L.Icon({
    // iconUrl: 'https://cdn-icons-png.flaticon.com/512/2231/2231649.png',
    iconUrl: SantaMonicaLogo,
    iconSize: [40, 40],
    iconAnchor: [20, 40],
    popupAnchor: [0, -40]
});

// 2. Gerador de Ícone para Escolas Encontradas (Baseado na Dependência)
const createEscolaIcon = (tp_dependencia) => {
    const cor = CORES_DEPENDENCIA[tp_dependencia] || "#6c757d"; // Cinza padrão se não encontrar
    const svgHtml = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="30">
      <path fill="${cor}" stroke="#333" stroke-width="1.2" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
      <circle cx="12" cy="9" r="2.5" fill="white"/>
    </svg>
  `;

    return new L.DivIcon({
        className: 'custom-marker-escola',
        html: svgHtml,
        iconSize: [30, 42],
        iconAnchor: [15, 42],
        popupAnchor: [0, -45]
    });
};

// --- COMPONENTE AUXILIAR PARA RECENTRALIZAR O MAPA ---
const ChangeMapViews = ({ center, zoom }) => {
    const map = useMap();
    useEffect(() => {
        if (center) {
            map.setView(center, zoom);
        }
    }, [center, zoom, map]);
    return null;
};

// --- COMPONENTE PRINCIPAL ---
const Mapa_escolas = ({ unidade, range }) => {
    const [escolas, setEscolas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [mapConfig, setMapConfig] = useState({ center: [-22.866478, -43.362688], zoom: 13 });

    // Encontrar a configuração da unidade selecionada
    const unidadeInfo = useMemo(() => {
        // 1. Se for string de expansão, cria uma unidade virtual dinâmica
        if (typeof unidade === 'string' && unidade.startsWith('EXP:')) {
            const partes = unidade.substring(4).split(',');
            return {
                id: 'EXP',
                nome: 'NOVO IMÓVEL (ALVO)',
                lat: parseFloat(partes[0]),
                lng: parseFloat(partes[1]),
                cor: '#000000' // Cor do raio do alvo
            };
        }
        // 2. Comportamento antigo normal
        return UNIDADES_CONFIG.find(uni => uni.id === unidade);
    }, [unidade]);

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha', 'Freguesia', 'Recreio'];

    // Raio em metros para o componente Circle
    const radiusInMeters = useMemo(() => {
        return parseFloat(range) * 1000;
    }, [range]);

    useEffect(() => {
        const fetchEscolas = async () => {
            if (!unidade || !range) return;

            setLoading(true);
            try {
                if (unidadeInfo) {
                    let dynamicZoom = 14;
                    if (range >= 5) dynamicZoom = 12;
                    if (range >= 10) dynamicZoom = 11;
                    if (range >= 15) dynamicZoom = 10;

                    setMapConfig({
                        center: [unidadeInfo.lat, unidadeInfo.lng],
                        zoom: dynamicZoom
                    });
                }

                const response = await geo_buscar_escola(unidade, range);
                const data = Array.isArray(response) ? response : (response?.data || []);

                const dadosFormatados = data.map(escola => ({
                    ...escola,
                    latitude: parseFloat(escola.latitude),
                    longitude: parseFloat(escola.longitude)
                }));

                setEscolas(dadosFormatados);
            } catch (error) {
                console.error("Erro ao carregar escolas no range:", error);
                setEscolas([]);
            } finally {
                setLoading(false);
            }
        };

        fetchEscolas();
    }, [unidade, range, unidadeInfo]);

    return (
        <div style={{ position: 'relative', height: '100%', width: '100%', minHeight: '500px' }}>

            {loading && (
                <div style={{
                    position: 'absolute',
                    zIndex: 2000,
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(255,255,255,0.7)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontWeight: 'bold'
                }}>
                    Carregando Escolas na Região...
                </div>
            )}

            {!unidade || !range ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#f9f9f9', minHeight: '500px' }}>
                    Selecione uma unidade e um range para visualizar o mapa.
                </div>
            ) : (
                <MapContainer
                    center={mapConfig.center}
                    zoom={mapConfig.zoom}
                    scrollWheelZoom={true}
                    style={{ height: "100%", width: "100%", borderRadius: '4px', minHeight: '500px' }}
                >
                    <ChangeMapViews center={mapConfig.center} zoom={mapConfig.zoom} />

                    <TileLayer
                        attribution='© <a href="https://www.openstreetmap.org/">OSM</a>'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />

                    {unidadeInfo && (
                        <React.Fragment>
                            <Circle
                                center={[unidadeInfo.lat, unidadeInfo.lng]}
                                radius={radiusInMeters}
                                pathOptions={{
                                    color: unidadeInfo.cor,
                                    fillColor: unidadeInfo.cor,
                                    fillOpacity: 0.1,
                                    weight: 2,
                                    dashArray: '5, 10'
                                }}
                            />
                            <Marker position={[unidadeInfo.lat, unidadeInfo.lng]} icon={schoolIcon}>
                                <Popup>
                                    <strong>UNIDADE BASE: {unidadeInfo.nome}</strong><br />
                                    Range definido: {range} km
                                </Popup>
                            </Marker>
                        </React.Fragment>
                    )}

                    {escolas.map((escola) => (
                        <Marker
                            key={escola.co_entidade}
                            position={[escola.latitude, escola.longitude]}
                            icon={createEscolaIcon(escola.tp_dependencia)} // O ícone agora é gerado com a cor da dependência
                        >
                            <Popup>
                                <strong>{escola.no_entidade}</strong><br />
                                {escola.no_municipio} / {escola.no_bairro}<br />
                                <strong style={{ color: CORES_DEPENDENCIA[escola.tp_dependencia] }}>{DEPENDENCIA_NOME[escola.tp_dependencia] || 'Não informada'}</strong><br />
                                Endereço: {escola.ds_endereco}, {escola.nu_endereco}
                                {escola.nu_telefone && <><br />Tel: {escola.nu_telefone}</>}
                            </Popup>
                        </Marker>
                    ))}

                </MapContainer>
            )}

            {unidadeInfo && !loading && (
                <div className="mapa-legenda" style={{
                    position: 'absolute',
                    bottom: '20px',
                    right: '20px',
                    zIndex: 1000,
                    backgroundColor: 'white',
                    padding: '10px',
                    borderRadius: '5px',
                    boxShadow: '0 0 5px rgba(0,0,0,0.3)',
                    borderLeft: `5px solid ${unidadeInfo.cor}` // Mantém a borda principal com a cor da unidade
                }}>
                    <h4 style={{ margin: '0 0 5px 0', fontSize: '14px' }}>Legenda</h4>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                        <img src={SantaMonicaLogo} alt="SMREDE" style={{ width: '20px', height: '20px', marginRight: '5px' }} />
                        <span style={{ fontSize: '12px', fontWeight: 'bold' }}>{unidades[parseInt(unidade)] || 'Não informada'}</span>
                    </div>

                    <div style={{ fontSize: '11px', color: '#666', marginBottom: '4px' }}>Escolas Concorrentes ({escolas.length}):</div>

                    {/* Legenda: Particular */}
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '3px', paddingLeft: '5px' }}>
                        <div style={{
                            width: '15px', height: '15px', borderRadius: '50%',
                            backgroundColor: CORES_DEPENDENCIA[4], border: '2px solid white',
                            boxShadow: '0 0 2px rgba(0,0,0,0.5)', marginRight: '5px'
                        }}></div>
                        <span style={{ fontSize: '12px' }}>Particular</span>
                    </div>

                    {/* Legenda: Pública */}
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px', paddingLeft: '5px' }}>
                        <div style={{
                            width: '15px', height: '15px', borderRadius: '50%',
                            backgroundColor: CORES_DEPENDENCIA[1], border: '2px solid white',
                            boxShadow: '0 0 2px rgba(0,0,0,0.5)', marginRight: '5px'
                        }}></div>
                        <span style={{ fontSize: '12px' }}>Pública (Fed)</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px', paddingLeft: '5px' }}>
                        <div style={{
                            width: '15px', height: '15px', borderRadius: '50%',
                            backgroundColor: CORES_DEPENDENCIA[2], border: '2px solid white',
                            boxShadow: '0 0 2px rgba(0,0,0,0.5)', marginRight: '5px'
                        }}></div>
                        <span style={{ fontSize: '12px' }}>Pública (Est)</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px', paddingLeft: '5px' }}>
                        <div style={{
                            width: '15px', height: '15px', borderRadius: '50%',
                            backgroundColor: CORES_DEPENDENCIA[3], border: '2px solid white',
                            boxShadow: '0 0 2px rgba(0,0,0,0.5)', marginRight: '5px'
                        }}></div>
                        <span style={{ fontSize: '12px' }}>Pública (Mun)</span>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '3px', borderTop: '1px solid #eee', paddingTop: '5px' }}>
                        <div style={{
                            width: '15px', height: '2px',
                            borderTop: `2px dashed ${unidadeInfo.cor}`,
                            marginRight: '5px'
                        }}></div>
                        <span style={{ fontSize: '12px' }}>Raio de {range} km</span>
                    </div>
                </div>
            )}

        </div>
    );
};

export default Mapa_escolas;